export { default } from 'lodash/template';

